import React from 'react';
import './App.css';
import AppRoutes from './routes/AppRoutes';

class App extends React.Component {
  render() {
    return <AppRoutes />;
  }
}

export default App;
